
    const truncateTitleIfOverMaxHeight = () => {
        // Get all upcoming title elements
        const upcomingTitles = [...document.querySelectorAll('.troxy-home-upcoming__title')];
        // Loop through titles 
        upcomingTitles.forEach(title => {

            const maxTitleHeight = 42;
            // Check title element height is over the max title height
            if(title.offsetHeight > maxTitleHeight) {
                // Add truncate class to title element to truncate text
                title.classList.add('truncate')
            }
        })
    }

    // Run truncate function
    truncateTitleIfOverMaxHeight();
